import i18n from "config/i18next";

i18n.addResources("es", "detailPresettlement", {
  presettlement: "Preliquidación",
  invoice: "Factura",
  presettlementNumber: "Número de preliquidación",
  plus: "Suma",
  subtract: "Resta",
  packages: "paquetes",
  package: "paquete",
  initialState: "En generación",
  pending: "Pendiente",
  inApprovement: "En aprobación",
  approved: "Aprobada",
  pendingAcounting: "Pendiente de contabilidad",
  inAcounting: "En contabilidad",
  generatedPayment: "Pago generado",
  invoiceRejected: "Factura rechazada",
  adjustment: "Modificación",
});
